export class QuestionsModel {
    question: string;
    qno: string;
    /**
     * 
     * @param qno 
     * @param question 
     */
    constructor(qno: string, question: string) {
        this.qno = qno;
        this.question = question;
    }
}